export class DashboardList {
  static readonly type = '[DashboardList] Post';
  constructor(public param: {}) {}
}
